import { Button } from '@/common/ui/button'
import {
	AlertDialog,
	AlertDialogAction,
	AlertDialogCancel,
	AlertDialogContent,
	AlertDialogDescription,
	AlertDialogFooter,
	AlertDialogHeader,
	AlertDialogTitle,
	AlertDialogTrigger,
} from '@/common/ui/alert-dialog'
import { Trash2 } from 'lucide-react'
import useMutationDeletePlayer from '@/modules/manage-player/api/hooks/useMutationDeletePlayer'
import { useQueryClient } from '@tanstack/react-query'
import { PlayerQueryKeys } from '@/modules/manage-player/keys'
import { toast } from 'sonner'
import showErrorToast from '@/common/utils/showErrorToast'

interface PlayerDeleteButtonProps {
	playerId: string
	playerUsername: string
}

export function PlayerDeleteButton({
	playerId,
	playerUsername,
}: PlayerDeleteButtonProps) {
	const queryClient = useQueryClient()

	const { mutate: deletePlayer } = useMutationDeletePlayer({
		onSuccess: () => {
			queryClient.invalidateQueries({
				queryKey: [PlayerQueryKeys.GetPlayerList],
			})
			toast.success('ลบผู้เล่นสำเร็จ')
		},
		onError: (error) => {
			showErrorToast(error)
		},
	})

	const handleDelete = () => {
		deletePlayer({ id: playerId })
	}

	return (
		<AlertDialog>
			<AlertDialogTrigger asChild>
				<Button variant="ghost" size="icon">
					<Trash2 className="h-4 w-4 text-destructive" />
				</Button>
			</AlertDialogTrigger>
			<AlertDialogContent>
				<AlertDialogHeader>
					<AlertDialogTitle>ยืนยันการลบผู้เล่น</AlertDialogTitle>
					<AlertDialogDescription>
						คุณต้องการลบผู้เล่น {playerUsername} ใช่หรือไม่?
						การดำเนินการนี้ไม่สามารถย้อนกลับได้
					</AlertDialogDescription>
				</AlertDialogHeader>
				<AlertDialogFooter>
					<AlertDialogCancel>ยกเลิก</AlertDialogCancel>
					<AlertDialogAction
						onClick={handleDelete}
						className="bg-destructive hover:bg-destructive/90"
					>
						ลบ
					</AlertDialogAction>
				</AlertDialogFooter>
			</AlertDialogContent>
		</AlertDialog>
	)
}
